/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../SVGWrapper';

function TvInfoIcon({ height = 32, width = 32 }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 70 70"
      fill="none"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35 67.8127C53.1218 67.8127 67.8125 53.1221 67.8125 35.0002C67.8125 16.8784 53.1218 2.18774 35 2.18774C16.8782 2.18774 2.1875 16.8784 2.1875 35.0002C2.1875 53.1221 16.8782 67.8127 35 67.8127ZM50.1136 35.0002C50.1136 43.3479 43.3468 50.1139 35.0005 50.1139C26.6531 50.1139 19.8864 43.3478 19.8864 35.0002C19.8864 26.6527 26.6531 19.8866 35.0005 19.8866C43.3468 19.8866 50.1136 26.6526 50.1136 35.0002ZM52.5 35.0002C52.5 44.6659 44.6648 52.5002 35.0005 52.5002C25.3352 52.5002 17.5 44.6659 17.5 35.0002C17.5 25.3346 25.3352 17.5002 35.0005 17.5002C44.6648 17.5002 52.5 25.3346 52.5 35.0002ZM36.5909 29.039C36.5909 29.9176 35.8786 30.6299 35 30.6299C34.1214 30.6299 33.4091 29.9176 33.4091 29.039C33.4091 28.1604 34.1214 27.4481 35 27.4481C35.8786 27.4481 36.5909 28.1604 36.5909 29.039ZM35 33.0077C34.341 33.0077 33.8068 33.5413 33.8068 34.1995V41.3614C33.8068 42.0196 34.341 42.5532 35 42.5532C35.659 42.5532 36.1932 42.0196 36.1932 41.3614V34.1995C36.1932 33.5413 35.659 33.0077 35 33.0077Z" fill="white" />
    </SVGWrapper>
  );
}

export default TvInfoIcon;
